import { ReactComponent as CheckImg } from '../assets/Check.svg';
import { ReactComponent as Star1 } from '../assets/Star.svg';
import { BgCheck, Wrapper } from './index.view';

const AnimationSuccess = () => {
  return (
    <>
      <Wrapper>
        <Star1 />
        <Star1 />
        <CheckImg />
      </Wrapper>
      <BgCheck />
    </>
  );
};

export default AnimationSuccess;
